module.exports = __webpack_public_path__ + "static/media/Blocks.2b81d4fe.png";